import { ChartDisplayElementModel } from '../../../Reports/models/chart-display-element.model';
import { DropdownFieldModel } from '../../../PageBuilder/models/dropdown-field.model';
import { DropdownFieldComponent } from '../../../PageBuilder/components/FormFields/DropdownField/dropdown-field.component';
import { BlockTypeModel } from '../../../PageBuilder/models/block-type.model';
import { ReportBlockTypeEnum } from '../../../Reports/enums/report-block-type.enum';
import { ListChartBlockComponent } from '../../../Reports/components/ListChartBlock/list-chart-block.component';
import { TextFieldModel } from '../../../PageBuilder/models/text-field.model';
import { TextFieldComponent } from '../../../PageBuilder/components/FormFields/TextField/text-field.component';
import { FilterFieldModel } from '../../../PageBuilder/models/filter-field.model';
import { FilterFieldComponent } from '../../../PageBuilder/components/FormFields/FilterField/filter-field.component';
// eslint-disable-next-line max-len
import { ChartDisplaySettingsFieldComponent } from '../../../Reports/components/ChartDisplaySettingsField/chart-display-settings-field.component';
import { ChartHeaderElementsEnum } from '../../../Charts/models/chart-display-settings.model';
import { ChartDisplaySettingsFieldModel } from '../../../Reports/models/chart-display-settings-field.model';

// Recent TargetingActivity
export const recentTargetingActivityBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.RECENT_TARGETING_ACTIVITY,
    `Dashboard.chart.title.${ReportBlockTypeEnum.RECENT_TARGETING_ACTIVITY}`,
    'fa fa-th-list',
    null,
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DropdownFieldModel(
            DropdownFieldComponent,
            'numOfItems',
            'Dashboard.field.numberOfItems',
            null,
            [
                {label: '5', value: '5'},
                {label: '10', value: '10'},
                {label: '15', value: '15'},
                {label: '20', value: '20'},
                {label: '25', value: '25'},
            ]
        ),
        new FilterFieldModel(
            FilterFieldComponent,
            'contentFilters',
            'Dashboard.field.filter.contentFilters',
            'Dashboard.field.filter.quicksearch.placeholder',
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            '',
            [ChartHeaderElementsEnum.TITLE]
        )
    ],
    ListChartBlockComponent
);
